import React from 'react';
import { Col, Row } from 'reactstrap';

const Footer = () => (
  <footer className="psi-app-footer">
    <Row noGutters className="justify-content-between align-items-center text-center text-md-left fs--1">
      <Col md="auto" className="mb-2 mb-md-0">
        <p className="mb-0 psi-app-footer-copy">Psixologik boshqaruv paneli | {new Date().getFullYear()}</p>
      </Col>
      <Col md="auto">
        <p className="mb-0 psi-app-footer-note">Suvoriy tomonidan ishlab chiqilgan</p>
      </Col>
    </Row>
  </footer>
);

export default Footer;
